import clone from "lodash/clone";
import { ModelProperty } from "./ModelProperty";
import { ModelBase } from "./ModelBase";
import { StorageBase } from "./StorageBase";

/**
 */
export class StorageManager {
  /**
   */
  public model: ModelBase;

  /**
   */
  public storage: StorageBase;

  private modelCtor: typeof ModelBase;
  private storageCtor: typeof StorageBase;

  /**
   * @param modelCtor Model constructor.
   * @param storageCtor Optional storage adapter.
   */
  constructor(modelCtor: typeof ModelBase, storageCtor?: typeof StorageBase) {
    this.setStorageAdapter(storageCtor || StorageBase);
    this.setStorageModel(modelCtor);
    this.recallStorage();
  }

  /**
   *
   * @param storageCtor
   */
  private setStorageAdapter(storageCtor: typeof StorageBase) {
    this.storageCtor = storageCtor;
    this.storage = new storageCtor();
  }

  /**
   */
  private setStorageModel(modelCtor: typeof ModelBase) {
    this.modelCtor = modelCtor;
    this.model = new modelCtor();
  }

  /**
   * @param {string} key
   * @param {any} value
   */
  public setItem(key: string, value: any) {
    let item: ModelProperty = this.model.properties[key];
    if (typeof item !== "undefined") item.value = value;
    this.updateStorage();
  }

  /**
   * @param {string} key
   * @returns {any}
   */
  public getItem(key: string): any {
    let item: ModelProperty = this.model.properties[key];
    return item && item.value;
  }

  /**
   */
  public clear() {
    this.model = new this.modelCtor();
    this.checkDefaults();
    this.updateStorage();
  }

  /**
   */
  private checkDefaults() {
    for (const key in this.model.properties) {
      if (this.model.properties.hasOwnProperty(key)) {
        const property = this.model.properties[key];
        if (typeof property.value === "undefined") property.value = clone(property.default);
      }
    }
  }

  /**
   */
  private recallStorage(): any {
    const storageItem = this.storage.getItem(this.model.storageKey);
    if (storageItem) this.model.deSerialize(storageItem);
    this.checkDefaults();
    this.updateStorage();
  }

  /**
   */
  private updateStorage() {
    const key = this.model.storageKey;
    const model = this.model.serialize();
    this.storage.setItem(key, model);
  }
}
